export default {
  id: null,
  companyID: null,
  areaID: null,
  insuranceID: null,
  stageID: null,
  schedulingTypeID: null,
  name: null,
  green: null,
  yellow: null,
  red: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/regulation/lighthousemodel.js